<template>
  <component
    :is="isLink ? 'a' : 'button'"
    :type="isLink ? undefined : type"
    :disabled="isLink ? undefined : disabled"
    :href="isLink ? linkHref : undefined"
    :target="isLink ? linkTarget : undefined"
    class="tw-inline-flex tw-justify-center tw-rounded-full tw-border-2 tw-px-10 tw-py-1 tw-pt-1.5 tw-font-medium focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-bridgit-lightBlue focus-visible:tw-ring-offset-2"
    :class="classes"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts">
import { ButtonHTMLAttributes, defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String as PropType<NonNullable<ButtonHTMLAttributes['type']>>,
      default: 'button',
    },
    variant: {
      type: String as PropType<'primary' | 'secondary' | 'link'>,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    linkHref: {
      type: String,
      default: undefined,
    },
    linkTarget: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    isLink() {
      return !!this.linkHref && !this.disabled;
    },
    classes() {
      switch (this.variant) {
        case 'primary':
          return [
            'tw-border-transparent',
            'tw-text-navy',
            'tw-bg-bridgit-vibrantGreen',
            this.disabled ? 'tw-opacity-50' : 'hover:tw-bg-bridgit-vibrantGreen-150',
          ];
        case 'secondary':
          return [
            'tw-border-bridgit-navy',
            'tw-text-bridgit-navy',
            this.disabled ? 'tw-opacity-50' : 'hover:tw-border-bridgit-royalBlue hover:tw-text-bridgit-royalBlue',
          ];
        default:
          return [
            'tw-border-transparent',
            'tw-text-bridgit-navy',
            'tw-underline',
            'tw-px-0 tw-py-0',
            this.disabled ? 'tw-opacity-50' : 'hover:tw-text-bridgit-royalBlue',
          ];
      }
    },
  },
});
</script>
